import { SimManagementError } from '../models/Errors';
import {
  ENSURE_DIRECTLY_AVAILABLE_COMMAND_TYPES,
  LOAD_DIRECTLY_AVAILABLE_COMMAND_TYPES,
  LOAD_DIRECTLY_AVAILABLE_COMMAND_TYPES_FAILURE,
  LOAD_DIRECTLY_AVAILABLE_COMMAND_TYPES_PENDING,
  LOAD_DIRECTLY_AVAILABLE_COMMAND_TYPES_SUCCESS
} from './actionTypes';
import { Action, ActionMeta } from './commonActions';

export interface LoadDirectlyAvailableCommandTypesFilter {
  serialNumbers: string[];
  isAtlasAccount: boolean;
}

/**
 * Action which loads the directly-available commands from the server if required.
 * @param payload The serial numbers for the currently selected stock.
 */
export function ensureDirectlyAvailableCommandTypes(
  payload: LoadDirectlyAvailableCommandTypesFilter
): Action<LoadDirectlyAvailableCommandTypesFilter> {
  return {
    type: ENSURE_DIRECTLY_AVAILABLE_COMMAND_TYPES,
    payload
  };
}

/**
 * Action which loads the directly-available commands from the server.
 * @param payload The serial numbers for the currently selected stock.
 */
export function loadDirectlyAvailableCommandTypes(
  payload: LoadDirectlyAvailableCommandTypesFilter
): Action<LoadDirectlyAvailableCommandTypesFilter> {
  return {
    type: LOAD_DIRECTLY_AVAILABLE_COMMAND_TYPES,
    payload
  };
}

/**
 * Action which sets the load status of the directly-available command types to pending.
 * @param payload The serial numbers for the currently selected stock.
 */
export function loadDirectlyAvailableCommandTypesPending(
  payload: LoadDirectlyAvailableCommandTypesFilter
): Action<LoadDirectlyAvailableCommandTypesFilter> {
  return {
    type: LOAD_DIRECTLY_AVAILABLE_COMMAND_TYPES_PENDING,
    payload
  };
}

/**
 * Action which handles when the directly-available command types are successfully loaded.
 * @param meta The filter criteria.
 * @param data A list of available command types.
 */
export function loadDirectlyAvailableCommandTypesSuccess(
  meta: LoadDirectlyAvailableCommandTypesFilter,
  data: number[]
): ActionMeta<number[], LoadDirectlyAvailableCommandTypesFilter> {
  return {
    type: LOAD_DIRECTLY_AVAILABLE_COMMAND_TYPES_SUCCESS,
    payload: data,
    meta
  };
}

/**
 * Action which handles when there is a failure to load the directly-available command types.
 * @param meta The filter criteria.
 * @param error The error.
 */
export function loadDirectlyAvailableCommandTypesFailure(
  meta: LoadDirectlyAvailableCommandTypesFilter,
  error: SimManagementError
): ActionMeta<SimManagementError, LoadDirectlyAvailableCommandTypesFilter> {
  return {
    error: true,
    type: LOAD_DIRECTLY_AVAILABLE_COMMAND_TYPES_FAILURE,
    payload: error,
    meta
  };
}
